/* eslint-disable import/prefer-default-export */
import * as Yup from 'yup'
import { VALIDATION_KEYS } from '../utils/translation-constants'

import validationConfig from "custom/config/validation.config.json";
const changePasswordConfig = validationConfig["changePassword"];
const setAccountNameConfig = validationConfig['setAccountName']

const validateNewPassword = changePasswordConfig["isNewPasswordRequired"]
  ? {
    newPassword: Yup.string()
    .required(VALIDATION_KEYS.NEW_PASSWORD_REQUIRED)
    .min(8, VALIDATION_KEYS.NEW_PASSWORD_MIN_LENGTH)
    .max(13, VALIDATION_KEYS.NEW_PASSWORD_MAX_LENGTH),
  }
  : {
    newPassword: Yup.string().optional(),
  };

const validateConfirmPassword = changePasswordConfig[
  "isConfirmNewPasswordRequired"
]
  ? {
    confirmPassword: Yup.string()
    .oneOf([Yup.ref('newPassword'), null], VALIDATION_KEYS.CONFIRM_PASSWORD_NOT_MATCH)
    .required(VALIDATION_KEYS.CONFIRM_PASSWORD_REQUIRED),
  }
  : {
    confirmPassword: Yup.string().optional(),
  };

const validateCurrentPassword = changePasswordConfig["isNewPasswordRequired"]
  ? {
    oldPassword: Yup.string().required(VALIDATION_KEYS.CURRENT_PASSWORD_REQUIRED),
  }
  : {
    oldPassword: Yup.string().optional(),
  };

  const validateAccountNickName = setAccountNameConfig["isShortNameRequired"]
  ? {
    accountNickName: Yup.string()
    .required(VALIDATION_KEYS.SHORT_NAME_REQUIRED)
    .min(2,VALIDATION_KEYS.SHORT_NAME_MIN_MAX)
    .max(20, VALIDATION_KEYS.SHORT_NAME_MIN_MAX),
  }
  : {
    accountNickName: Yup.string().optional(),
  };

  const validateAccountNo = setAccountNameConfig["isAccountNoRequired"]
  ? {
    accountNumber: Yup.string().required(VALIDATION_KEYS.ACCOUNT_NO_REQUIRED),
  }
  : {
    accountNumber: Yup.string().optional(),
  };

export const ChangePasswordSchema = Yup.object().shape({
  ...validateNewPassword,
  ...validateConfirmPassword,
  ...validateCurrentPassword,
})

export const AddAccountNameSchema = Yup.object().shape({
  ...validateAccountNickName,
  // .matches(new RegExp('[a-zA-Z]$'), 'Please enter Short Name'),
  ...validateAccountNo
})
